import { render, staticRenderFns } from "./DataObjectModal.vue?vue&type=template&id=6497b214&scoped=true&"
import script from "./DataObjectModal.vue?vue&type=script&lang=js&"
export * from "./DataObjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6497b214",
  null
  
)

export default component.exports